// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
.portal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: black;
  transition: opacity 0.5s ease;
  z-index: 9999;
}

.portal-hidden {
  opacity: 0;
  pointer-events: none;
}

/* Logo Animation */
.portal-logo {
  width: 400px;
  height: auto;
  margin-bottom: 200px; /* Move the logo closer to the top */
  animation: scale-up-down 5s infinite ease-in-out;
  opacity: 1;
  transition: opacity 1s ease;
}

.portal-logo.exit {
  opacity: 0;
  animation: none;
}

/* Loader/Button Animation */
.loader-button {
  width: 100px; /* Increased size */
  height: 100px; /* Increased size */
  border-radius: 50%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  animation: move-down 3s forwards;
  cursor: pointer;
}

.loader-button.initial span {
  display: none; /* Hide the text in the initial state */
}

.loader-button.button span {
  display: block; /* Show the text in the button state */
}

.outtro-text {
  font-size: 24px; /* Make the "Enter" text larger */
  color: white;
  width: 100px;
  height: 100px;
  z-index: 10000;
  margin-top: 50px;
  position: absolute;
  text-align: center;
}

/* Exit animation for the loader button */
.portal-overlay.exit .loader-button {
  animation: move-up-scale 2s forwards;
}

/* Animations */
@keyframes move-down {
  0% {
    transform: scale(0.2) translateY(0);
  }
  100% {
    transform: scale(1) translateY(200px);
  }
}

@keyframes move-up-scale {
  0% {
    transform: translateY(200px) scale(1);
    opacity: 1;
  }
  90% {
    transform: translateY(0) scale(8);
    opacity: 0.5;
  }
  100% {
    transform: translateY(0) scale(10);
    opacity: 0;
  }
}

@keyframes scale-up-down {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}`, "",{"version":3,"sources":["webpack://./src/Outtro.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB,EAAE,oCAAoC;EAC1D,gDAAgD;EAChD,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,YAAY,EAAE,mBAAmB;EACjC,aAAa,EAAE,mBAAmB;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,eAAe,EAAE,iCAAiC;EAClD,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE;IACE,mCAAmC;EACrC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* General styles */\n.portal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: black;\n  transition: opacity 0.5s ease;\n  z-index: 9999;\n}\n\n.portal-hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Logo Animation */\n.portal-logo {\n  width: 400px;\n  height: auto;\n  margin-bottom: 200px; /* Move the logo closer to the top */\n  animation: scale-up-down 5s infinite ease-in-out;\n  opacity: 1;\n  transition: opacity 1s ease;\n}\n\n.portal-logo.exit {\n  opacity: 0;\n  animation: none;\n}\n\n/* Loader/Button Animation */\n.loader-button {\n  width: 100px; /* Increased size */\n  height: 100px; /* Increased size */\n  border-radius: 50%;\n  background-color: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  position: absolute;\n  animation: move-down 3s forwards;\n  cursor: pointer;\n}\n\n.loader-button.initial span {\n  display: none; /* Hide the text in the initial state */\n}\n\n.loader-button.button span {\n  display: block; /* Show the text in the button state */\n}\n\n.outtro-text {\n  font-size: 24px; /* Make the \"Enter\" text larger */\n  color: white;\n  width: 100px;\n  height: 100px;\n  z-index: 10000;\n  margin-top: 50px;\n  position: absolute;\n  text-align: center;\n}\n\n/* Exit animation for the loader button */\n.portal-overlay.exit .loader-button {\n  animation: move-up-scale 2s forwards;\n}\n\n/* Animations */\n@keyframes move-down {\n  0% {\n    transform: scale(0.2) translateY(0);\n  }\n  100% {\n    transform: scale(1) translateY(200px);\n  }\n}\n\n@keyframes move-up-scale {\n  0% {\n    transform: translateY(200px) scale(1);\n    opacity: 1;\n  }\n  90% {\n    transform: translateY(0) scale(8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: translateY(0) scale(10);\n    opacity: 0;\n  }\n}\n\n@keyframes scale-up-down {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
